import { createContext } from 'react';

import { initialState } from './reducer';
import { type ToastState, type ToastDispatchType } from './types';

/**
 * Separating dispatch and state contexts, so dispatch subscribers
 * would not rerender on state changes.
 */
const ToastStateContext = createContext<ToastState>(initialState);
const ToastDispatchContext = createContext<ToastDispatchType>(() => {});

export { ToastStateContext, ToastDispatchContext };
